export default __webpack_public_path__ + "f2cbb1d6dbb93131f690f191546f977a.mp3";